// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"fd1b338a","453":"c1c551c5"}[chunkId] + ".chunk.js";
};